module.exports = __webpack_public_path__ + "static/BOOKING FORM ANNEXE ONLY-9a4464a8799b031f8e4b4b145b470652.pdf";